<template>
  <div class="HomePageStyle">
    <top-component></top-component>
    <div class="container">
        <div class="kms" v-if="type==0">                  
            <video style="width: 100%; height: 100%;" controls="controls" autoplay="autoplay">
                <!-- 您的浏览器不支持 video 标签。 -->
                <source :src="videoLink" type="video/mp4" />
            </video>
        </div>
        <div class="booklist" v-if="type==1">
            <h2 class="partTitle">少儿绘本</h2>
            <el-row :gutter="18">
                <el-col :span="4" v-for="(item, index) in booklist" :key="index">
                    <el-card class="bookbox" :body-style="{ padding: '0'}" @click="BookDetailClick(item.goodsId)">
                        <img :src="item.imageUrl" class="image">
                        <div class="bookinfo">
                            <span class="title">{{ item.title }}</span>
                            <div class="bottom clearfix">
                                <time class="time">适合年龄段</time>
                                <b class="price">￥{{ item.price }}</b>
                            </div>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <div class="qgzWrap" v-if="type==2">
            <h2 class="partTitle">乔公子文创</h2>  
            <div class="qgzVideo_box">                     
                <video style="width: 100%; height: 100%;" controls="controls" autoplay="autoplay">
                    <!-- 您的浏览器不支持 video 标签。 -->
                    <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/73034d83086148e99eb5f839edf39397/fde53375ca7f42e1938ca26c2f4b4e59-9c0656b56240956d52a5b14f2771392e-sd.mp4" type="video/mp4" />
                </video> 
            </div>
            <div class="qgzImageslist">
                <img src="../../assets/qmyd/qgz/img1.jpeg" />
                <img src="../../assets/qmyd/qgz/img2.jpg" />
                <img src="../../assets/qmyd/qgz/img3.png" />
                <img src="../../assets/qmyd/qgz/img4.png" />
                <img src="../../assets/qmyd/qgz/img5.jpeg" />
                <img src="../../assets/qmyd/qgz/img6.jpeg" />
                <img src="../../assets/qmyd/qgz/img7.png" />
                <img src="../../assets/qmyd/qgz/img8.jpeg" />
                <img src="../../assets/qmyd/qgz/img9.png" />
            </div>
            <p style="margin:30px 0;color:#999;">本产品由湖北三新文化传媒有限公司独家代理线下销售，合作电话：18258113757</p>
        </div>
        <div class="partWrap" v-if="type==3">
            <h2 class="partTitle">志愿者招募</h2>
            <div class="bannerwrap">
                <div class="video_box">                    
                    <video style="width: 470px; height: 620px;" controls="controls" autoplay="autoplay">
                        <!-- 您的浏览器不支持 video 标签。 -->
                        <source src="https://outin-b41c3368774f11eabe3000163e06123c.oss-cn-shanghai.aliyuncs.com/cd0c90dc910a421c8bdd91a6efed20e7/a1d654409ef54f319d4c0f21387009c2-2a335ce87d207b914ac9ce595dde0b43-sd.mp4" type="video/mp4" />
                    </video>  
                </div>
                <!-- <img src="../../assets/qmyd/zyzBanner.jpeg" /> -->
            </div>
        </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>
<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import Cookies from 'js-cookie'
  import Axios from "@/api/diyaxios";
  import { getUserId } from '@/common/utils/utils'

    export default {
        data(){
            return{
                type:1,
                videoLink:'',
                booklist:[]
            }
        },
        components:{
            BottomComponent,
            TopComponent
        },
        mounted(){
            this.type = this.$route.params.type;            
            if(this.type == 0) this.getVideo();
            if(this.type == 1) this.getBooklist();
        },
        methods:{
            // 
            //开幕式视频
            getVideo(){
                let vm = this,
                    url = "/activity/action/select";
                Axios.post(url, { 
                    params: {
                        activityId: 1
                    }
                }).then(res => {
                    if(res.status){
                        vm.videoLink = res.data.records;
                    }

                }).catch(err => {});
            },
            //绘本列表
            getBooklist(){
                let vm = this,
                    url = "/rmdsupport/action/linkUrl";
                Axios.post(url, { 
                    params: {
                        activitytag:'10124',
                        current:1,
                        size: 18,
                        userid: Cookies.get('UserID'),
                        goodstype:1
                    }
                },
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                ).then(res => {
                    if(res.status){
                        vm.booklist = res.data.records;
                    }

                }).catch(err => {});
            },
            // 点击跳转详情页
            BookDetailClick(goodsId) {
                const { href } = this.$router.resolve({
                    name: "BookDetail",
                    params: { goodsId: goodsId }
                });
                window.open(href, "_blank");
            },
        }
    }

</script>

<style scoped lang="scss">
    .container{
        background-color: #fafafa;
        padding: 20px 0 40px;
    }
    .partTitle{
        color:#666;
        margin-bottom: 20px;
    }
    .qgzWrap{        
        width: 1000px;
        margin: 0px auto;
    }
    .partWrap .partTitle{
        width: 1200px;
        margin: 0px auto 30px;
    }
    .booklist{
        width: 1200px;
        margin: 0px auto;
        font-size:14px;
        .bookbox{
            cursor: pointer;
        }
        .bookinfo{
            padding:10px;
            border-top:1px solid #f9f9f9;
        }
        .time{
            color: #999;
            font-size: 12px;
        }
        .price{
            color: #f56c6c;
            float: right;
        }
        .title{
            height: 38px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            margin-bottom: 8px;
        }
        img{
            width:100%;
            height: 183px;
        }
        .el-card{
            margin-bottom: 18px;
        }
    }
    .qgzVideo_box{
        width: 1000px;
        height: 550px;
    }
    .bannerwrap{
        position: relative;
        width: 1920px;
        margin:0 auto;
        .video_box{
            position: absolute;
            left: 190px;
            top: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/qmyd/sehb.vue